<div class="signature-capture">
  <div class="signature-capture__canvas-wrapper">
    <canvas #signatureCanvas class="signature-capture__canvas"></canvas>
    <p class="signature-capture__hint">Dibuja tu firma en el recuadro</p>
  </div>
  <div class="signature-capture__actions">
    <button
      type="button"
      class="btn signature-capture__btn-clear"
      (click)="clear()">
      Limpiar
    </button>
    <button
      type="button"
      class="btn signature-capture__btn-confirm"
      (click)="confirm()">
      Confirmar firma
    </button>
  </div>
</div>
